'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
interface KakaobankExitConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}
export const KakaobankExitConfirmModal = t0 => {
  const $ = _c(11);
  const {
    opened,
    onClose,
    onConfirm
  } = t0;
  useOverlayHistory(opened, onClose);
  let t1;
  if ($[0] !== onClose) {
    t1 = <Button theme="sub-fill" onClick={onClose}>아니오</Button>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onConfirm) {
    t2 = <Button className="border-O-400 bg-O-400 hover:border-O-500 hover:bg-O-500 active:border-O-600 active:bg-O-600" onClick={onConfirm}>예</Button>;
    $[2] = onConfirm;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClose || $[8] !== opened || $[9] !== t3) {
    t4 = <Modal opened={opened} onClose={onClose} description={"\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80\uC81C \uC11C\uBE44\uC2A4\uB97C \uC885\uB8CC\uD560\uAE4C\uC694?"} buttonFooter={t3} />;
    $[7] = onClose;
    $[8] = opened;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};